module.exports = __webpack_public_path__ + "resources/img/img_passxpertv4_4_m.7e5c4097b86aeeb0f81755f308a7aaf9.png";